export default __webpack_public_path__ + "static/media/rena.c2d18c94.png";